module.exports = __webpack_public_path__ + "img/vital-mascotas.82e12fac.png";